export const fadeScaleInOut = {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0.95 },
    style: { originX: 0 },
    transition: { delay: 0.6 },
};
